// @context TGW-1769 Slack風チャンネルUIの表示用純関数群。コンポーネントから切り離して
//   Jest で単体テスト可能にするため純関数で実装。本文HTMLはBEの body_url_to_link
//   （エスケープ+リンク化済み）を正とし、FEで再エスケープ/再リンク化はしない（二重処理防止）。
//   ここでは「表示の組み立て」（グルーピング・日付区切り・@装飾・自分宛判定）だけを担う。

const GROUP_WINDOW_MS = 5 * 60 * 1000;

// @channel/@everyone は集合宛、それ以外は @名前（composer が空白なしで挿入する前提）。
// メールアドレス誤爆を防ぐため、@ の直前が行頭・空白・タグ境界(>)のときだけ装飾する。
const MENTION_TOKEN_RE = /(^|[\s>]|&nbsp;)(@(?:channel|everyone|[^\s<&@]+))/g;

function sameDay(a, b) {
  const da = new Date(a);
  const db = new Date(b);
  return (
    da.getFullYear() === db.getFullYear() &&
    da.getMonth() === db.getMonth() &&
    da.getDate() === db.getDate()
  );
}

// 直前メッセージと「同一送信者・5分以内・同日」なら Slack 風にアバター/名前を省略する
export function isGroupedWithPrev(message, prev) {
  if (!prev || !message) return false;
  if (!prev.user || !message.user || prev.user.id !== message.user.id)
    return false;
  if (!sameDay(prev.created_at, message.created_at)) return false;

  const diff =
    new Date(message.created_at).getTime() -
    new Date(prev.created_at).getTime();
  return diff >= 0 && diff <= GROUP_WINDOW_MS;
}

export function needsDateSeparator(message, prev) {
  if (!prev) return true;
  return !sameDay(prev.created_at, message.created_at);
}

const WEEKDAYS = ['日', '月', '火', '水', '木', '金', '土'];

export function dateSeparatorLabel(createdAt, now = new Date()) {
  const d = new Date(createdAt);
  const base = `${d.getMonth() + 1}月${d.getDate()}日(${WEEKDAYS[d.getDay()]})`;
  if (d.getFullYear() !== now.getFullYear()) {
    return `${d.getFullYear()}年${base}`;
  }
  if (sameDay(d, now)) return '今日';
  return base;
}

// body_url_to_link 済みHTMLのテキスト部分だけを対象に @トークンを装飾する。
// タグ内部（属性値）を触らないよう、タグ区切りで分割してテキスト断片のみ置換する。
export function decorateMentions(html) {
  if (!html) return html;
  return String(html)
    .split(/(<[^>]*>)/)
    .map((part) => {
      if (part.startsWith('<')) return part; // タグはそのまま
      return part.replace(
        MENTION_TOKEN_RE,
        '$1<span class="slackch-mention">$2</span>',
      );
    })
    .join('');
}

// 自分宛か（個人メンション or @channel/@everyone）。BEの Message#mentions を正とする。
const MENTION_TYPE_CHANNEL = 2;
const MENTION_TYPE_EVERYONE = 3;

export function isMentionedMe(message, currentUserId) {
  const mentions = (message && message.mentions) || [];
  return mentions.some(
    (m) =>
      m.mentioned_user_id === currentUserId ||
      m.mention_type === MENTION_TYPE_CHANNEL ||
      m.mention_type === MENTION_TYPE_EVERYONE,
  );
}

export default {
  isGroupedWithPrev,
  needsDateSeparator,
  dateSeparatorLabel,
  decorateMentions,
  isMentionedMe,
};
